var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconDone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11.0005L6.5 12.5005L12.429 18.6304L23 8.00049L21.5 6.50049L12.5 15.5005L8 11.0005Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5005L2.5 11.0005L8 17.0005L6.5 18.5005L1 12.5005Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0005L17.2635 7.52554L15.8492 6.11133L10.5 11.5005L12 13.0005Z",
    fill: "#002CFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckDouble);
export default __webpack_public_path__ + "static/media/iconCheckDouble.df2f7b04baa949a1ac7bc5bfe0a5a29b.svg";
export { ForwardRef as ReactComponent };